export const PermissionsSetInitialState = () => {
    let permissions: any = []

    const permissionsObject = localStorage.getItem('permissions');

    if(permissionsObject) {
        permissions = JSON.parse(permissionsObject);
    }

    return permissions;
}